import { find, get } from 'lodash-es';

export default {
  /**
   * Retrieves a list of countries under the ski product type.
   *
   * @param state
   * @returns {Array|*}
   */
  skiCountries(state) {
    if (!state.auth.products || !state.auth.products.length) {
      return [];
    }

    const skiProduct = find(state.auth.products, { slug: 'skiferie' });

    if (!skiProduct) {
      return [];
    }

    return get(skiProduct, 'countries', []);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js